import {
  Component,
  Input,
  QueryList,
  ContentChildren,
  AfterViewInit,
  TemplateRef,
  ViewChildren,
  ViewChild,
  ContentChild
} from '@angular/core';

import { cloneDeep } from 'lodash';
import {
  NgxQueryComponent,
  FieldDirective,
  translateTemplates,
  Field,
  GroupOpType,
  DataType,
  ValueInputTemplateDirective
} from '@zhongruigroup/ngx-query';

import { ShowSettingServiceService } from '../../services/show-setting-service.service';
import {
  SelectCondition,
  UnionQueryPara,
  DynamicSelectColumn,
  getSelectConditionIdentity,
  Condition,
  ControlTypeName
} from '../../types';
import { NgxQueryDynamicCustom } from '../../types/query-dynamic.types';

@Component({
  selector: 'df-ngx-query-dynamic',
  templateUrl: './ngx-query-dynamic.component.html',
  styleUrls: ['./ngx-query-dynamic.component.css']
})
export class NgxQueryDynamicComponent implements AfterViewInit {
  @Input() formCode: string;
  @Input() templateIndex: number = 0;
  @Input() op: string = 'and';

  // dataTable æä»¤
  @Input() ngxDataTable: any;

  // ngx-query
  @Input() ngxQuery: NgxQueryComponent;

  // ç»ä»¶æ¨¡æ¿è®¾ç½®
  @Input() dateFormat: string = 'YYYY-MM-DD';
  @Input() datePickerReadonly: boolean = false;

  // å¤éæ¡è®¾ç½®
  @Input() multiMaxSelectedLabels: number = 10;
  @Input() multiSelectedItemsLabel: string = 'å·²éæ© {0} é¡¹';
  @Input() multiSelectDefaultLabel = '--è¯·éæ©--';

  @Input() globalData: any;

  @ContentChildren(FieldDirective)
  set fieldTemplates(val: QueryList<FieldDirective>) {
    this._fieldTemplates = val;
  }
  get fieldTemplates(): QueryList<FieldDirective> {
    return this._fieldTemplates;
  }

  @ContentChild('ngxQueryDynamicCustom')
  set customTemplates(val: NgxQueryDynamicCustom) {
    this._customTemplates = val;
  }
  get customTemplates() {
    return this._customTemplates;
  }

  @ViewChildren(ValueInputTemplateDirective)
  set valueInputTemplates(val: QueryList<ValueInputTemplateDirective>) {
    this._valueInputTemplates = val;
  }
  get valueInputTemplates(): QueryList<ValueInputTemplateDirective> {
    return this._valueInputTemplates;
  }

  selectConditions: Array<SelectCondition>;
  condition: Condition;

  selectControlLoading: Array<string> = [];

  private _fieldTemplates: QueryList<FieldDirective>;
  private _valueInputTemplates: QueryList<ValueInputTemplateDirective>;
  private _customTemplates: NgxQueryDynamicCustom;

  constructor(private showSettingServiceService: ShowSettingServiceService) {}

  ngAfterViewInit(): void {
    this.loadForm();
  }

  executeQuery() {
    this.ngxQuery.executeQuery();
  }

  /**
   * @description è·åèåæ¥è¯¢åæ°
   *
   * @memberof NgxQueryDynamicComponent
   */
  getUnionParam(params: any): UnionQueryPara {
    return this.resetParam(
      this.formCode,
      this.selectConditions.map((s) => {
        return {
          entityCode: s.dataEntityCode,
          attributeName: s.dataAttrCode,
          dataType: this.getColumnDataType(s)
        };
      }),
      params
    );
  }

  resetParam(formCode: string, columns: Array<DynamicSelectColumn>, params: any): UnionQueryPara {
    const unionPara = new UnionQueryPara();
    unionPara.formCode = formCode;

    unionPara.columns = [];
    this.condition.showCondition.forEach((s) => {
      if (s.multiDataAttrCode && s.multiDataAttrCode.length > 0) {
        s.multiDataAttrCode.forEach((m) => {
          unionPara.columns.push({
            entityCode: s.dataEntityCode,
            attributeName: m.name
          });
        });
      } else {
        unionPara.columns.push({
          entityCode: s.dataEntityCode,
          attributeName: s.dataAttrCode
        });
      }
    });

    unionPara.request = params;
    const rules = unionPara.request.filter.rules;
    if (rules) {
      rules.forEach((s) => {
        const dynamicColumn = columns.find((u) => `${u.entityCode}.${u.attributeName}` === s.field);
        if (dynamicColumn) {
          s.isDynamic = true;
          s.type = dynamicColumn.dataType ? dynamicColumn.dataType : 'string';
        }
        // æ°å­ 0 bug
        if (s.data === 0) {
          s.data = '0';
        }
        // å¼æ¯æ°ç»
        if (s.data instanceof Array) {
          const datas = s.data as Array<any>;
          if (datas.length > 0) {
            s.data = JSON.stringify(datas);
          } else {
            s.data = null;
          }
        }
      });
    }

    const sorts = unionPara.request.sort;
    if (sorts) {
      sorts.forEach((s) => {
        const dynamicColumn = columns.find((u) => `${u.entityCode}.${u.attributeName}` === s.field);
        if (dynamicColumn) {
          s.isDynamic = true;
        }
      });
    }
    return unionPara;
  }

  /**
   * @description è·åæ°æ®ç±»å
   *
   * @memberof NgxQueryDynamicDirective
   */
  getDataType(condition?: SelectCondition): DataType {
    const templates = this.ngxQuery['_valueInputTemplates'] as QueryList<ValueInputTemplateDirective>;
    const conditionType = templates.find((s) => s.dataType.toString() === condition.type);
    if (conditionType) {
      return conditionType.dataType;
    }

    // æ ¹æ®æ§ä»¶ç±»åéæ©æ¨¡æ¿
    const type = condition.type.toLowerCase();
    if (type === ControlTypeName.radio.toLowerCase() || type === ControlTypeName.dropDown.toLowerCase()) {
      this.selectControlLoading.push(getSelectConditionIdentity(condition));
      return this.convertStringToDataType('dfSelect');
    }
    if (type === ControlTypeName.multiCheckBox.toLowerCase()) {
      return this.convertStringToDataType('dfMultiSelect');
    }
    if (type === ControlTypeName.switch.toLocaleLowerCase()) {
      return this.convertStringToDataType('dfCheckbox');
    }

    if (!condition || !condition.dataAttrOrigin || !condition.dataAttrOrigin.dataType) {
      return DataType.any;
    }

    // æ ¹æ®æ§ä»¶æ°æ®ç±»åéæ©æ¨¡æ¿
    const dataType = condition.dataAttrOrigin.dataType.toLowerCase();
    if (dataType === 'text' || dataType === 'string') {
      return this.convertStringToDataType('dfString');
    }

    if (dataType === 'int' || dataType === 'double' || dataType === 'decimal') {
      return this.convertStringToDataType('dfNumber');
    }

    if (dataType === 'bool') {
      return DataType.boolean;
    }

    if (dataType === 'datetime') {
      return this.convertStringToDataType('dfDate');
    }

    return this.convertStringToDataType('dfString');
  }

  /**
   * @description è·åæ¥è¯¢åæ°æ®ç±»å
   *
   * @memberof NgxQueryDynamicComponent
   */
  getColumnDataType(condition?: SelectCondition): string {
    if (!condition || !condition.dataAttrOrigin || !condition.dataAttrOrigin.dataType) {
      return 'string';
    }
    const type = condition.dataAttrOrigin.dataType.toLowerCase();
    if (type === 'text' || type === 'string') {
      return 'string';
    }

    if (type === 'int') {
      return 'int';
    }

    if (type === 'double' || type === 'decimal') {
      return 'double';
    }

    if (type === 'decimal') {
      return 'decimal';
    }

    if (type === 'bool') {
      return 'bool';
    }

    if (type === 'datetime') {
      return 'datetime';
    }

    return 'string';
  }

  selectOptionsLoadComplete(name: string) {
    if (!name) {
      return;
    }
    this.selectControlLoading = this.selectControlLoading.filter((p) => p !== name);
  }

  private convertStringToDataType(typeName: string): DataType {
    return (typeName as unknown) as DataType;
  }

  private loadForm() {
    this.showSettingServiceService.getCondition(this.formCode).subscribe((s) => {
      this.setNgxQueryValueTemplate();
      this.condition = s;
      this.selectConditions = s.selectCondition;
      this.resetQuery(s.selectCondition);
    });
  }

  private setNgxQueryValueTemplate() {
    const oldTemplates = (this.ngxQuery['_valueInputTemplates'] as QueryList<ValueInputTemplateDirective>).toArray();

    // ç»ä»¶ç templates åè¿ä¸ªç»ä»¶ä¸æ ·ï¼ä¸è¿æ¯æä»ç æä»¤å¯¹è±¡æ¬å°è¿é
    oldTemplates.push(...this.valueInputTemplates.toArray());
    if (this.customTemplates) {
      oldTemplates.push(...this.customTemplates.valueInputTemplates.toArray());
    }
    this.ngxQuery['_valueInputTemplates'] = oldTemplates;
  }

  /**
   * @description éç½®æ¥è¯¢æ¡ä»¶
   *
   * @memberof NgxQueryDynamicComponent
   */
  private resetQuery(conditions: Array<SelectCondition>) {
    const tempFields: Field[] = [];
    conditions.forEach((s) => {
      const name = getSelectConditionIdentity({
        dataEntityCode: s.dataEntityCode,
        dataAttrCode: s.dataAttrCode
      });
      const field: Field = {
        name: name,
        label: s.caption,
        isCollapse: false,
        canDisable: false,
        type: this.getDataType(s),
        custom: undefined,
        valueInputTemplate: undefined,
        getRules: undefined,
        validate: undefined
      };
      tempFields.push(field);
    });

    for (let i = 0; i < tempFields.length; i++) {
      const temp = this.fieldTemplates.find((f) => f.name === tempFields[i].name);
      if (temp) {
        tempFields[i] = translateTemplates([temp])[0];
      }
    }

    this.ngxQuery.fields.push(...tempFields);
    this.ngxQuery.fields = cloneDeep(this.ngxQuery.fields);

    this.addTemplate(conditions);
  }

  /**
   * @description æ·»å æ¨¡æ¿ä¿¡æ¯
   *
   * @memberof NgxQueryDynamicComponent
   */
  private addTemplate(conditions: Array<SelectCondition>) {
    const template = this.ngxQuery.queryTemplates[this.templateIndex].template;

    conditions = conditions.sort((a, b) => {
      return a.serialNo - b.serialNo;
    });
    conditions.forEach((s) => {
      const name = getSelectConditionIdentity({
        dataEntityCode: s.dataEntityCode,
        dataAttrCode: s.dataAttrCode
      });
      template.rules.push({
        field: name,
        op: s.rule,
        data: '',
        datas: undefined
      });
    });
    // å è½½ç¼å­
    this.ngxDataTable.loadDynamicCachePaging();
    // éæ°èµæ¥è¯¢æ¡ä»¶
    this.ngxQuery.queryTemplates = this.ngxQuery.queryTemplates;

    // promiseçæ¹æ¡ä¸å¥½ç¨
    setTimeout(() => {
      // åæ¢ä¸ä¸æ¨¡æ¿ï¼å¦åæ¥è¯¢æ¡ä¸å·æ°
      this.ngxQuery.queryTemplateChanged({ name: '', template: { groups: [], rules: [], op: GroupOpType.AND } });
      setTimeout(() => {
        this.ngxQuery.queryTemplateChanged(this.ngxQuery.queryTemplates[0]);
        this.ngxDataTableRefreshData();
      }, 0);
    }, 0);
  }

  private ngxDataTableRefreshData() {
    setTimeout(() => {
      if (this.selectControlLoading.length === 0) {
        this.ngxDataTable.refreshData();
      } else {
        this.ngxDataTableRefreshData();
      }
    }, 5);
  }
}
